// extracted by mini-css-extract-plugin
export default {"hidden":"invisible_hidden__+ZV71"};